export default __webpack_public_path__ + "static/media/online.0f15fcae.mp3";